var render = function render(){var _vm=this,_c=_vm._self._c;return _c('trax-ui-table-with-actions',{attrs:{"id":_vm.id,"titles":_vm.titles,"actions":_vm.actions,"header":_vm.header,"header-color":_vm.headerColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }